import { render } from "./TextLimit.vue?vue&type=template&id=a6956f98&ts=true"
import script from "./TextLimit.vue?vue&type=script&lang=ts"
export * from "./TextLimit.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__